import { INPUT_PARTS, INPUT_VARIANTS } from "../inputVocabulary";

const focusRing = (theme) => `3px solid ${theme.palette.accent.butterscotch}`;

const searchPill = {
  root: ({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: theme.spacing(1),
    width: "100%",
    boxSizing: "border-box",
    padding: theme.spacing(1.5),
    // A px string: in sx a bare number would be multiplied by shape.borderRadius again.
    borderRadius: `${theme.shape.borderRadius * 15}px`,
    border: "1px solid",
    borderColor: theme.palette.neutral.searchStroke,
    backgroundColor: theme.palette.neutral.surface,
    cursor: "text",
    "&:focus-within": {
      borderColor: theme.palette.accent.butterscotch,
      outline: focusRing(theme),
      outlineOffset: theme.spacing(0.25),
    },
  }),
  icon: ({ theme }) => ({ color: theme.palette.neutral.body, fontSize: theme.typography.pxToRem(20), flexShrink: 0 }),
  input: ({ theme }) => ({
    flex: 1,
    minWidth: 0,
    color: theme.palette.neutral.headings,
    fontSize: theme.typography.pxToRem(14),
    "& .MuiInputBase-input": { padding: 0 },
  }),
  mic: ({ theme }) => ({
    color: theme.palette.primary.interactive,
    flexShrink: 0,
    minWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    padding: theme.spacing(0.5),
    "&:focus-visible": { outline: focusRing(theme), outlineOffset: theme.spacing(0.25) },
  }),
  error: ({ theme }) => ({
    display: "block",
    marginTop: theme.spacing(0.5),
    paddingInline: theme.spacing(1.5),
    color: theme.palette.formMessage.error,
  }),
};

export const inputRecipe = { variants: { searchPill } };

export function resolveInputPart(variant, part) {
  const parts = inputRecipe.variants[variant];
  if (!parts || !INPUT_PARTS.includes(part)) {
    throw new Error(`[input-variants] unknown "${variant}.${part}" — add to inputVocabulary.js + recipes/input.js first.`);
  }
  return parts[part];
}

// sx-ready: (theme) => style for one part.
export const inputPartSx = (variant, part) => {
  const factory = resolveInputPart(variant, part);
  return (theme) => factory({ theme });
};

export const INPUT_VARIANT_LIST = INPUT_VARIANTS;
